"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Jumbotron;
var _react = _interopRequireDefault(require("react"));
var _container = _interopRequireDefault(require("./container"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Jumbotron(props) {
  var _props$fluid;
  const fluid = (_props$fluid = props.fluid) !== null && _props$fluid !== void 0 ? _props$fluid : false;
  if (props.fullWidth) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "jumbotron-fluid"
    }, /*#__PURE__*/_react.default.createElement(_container.default, {
      fluid: fluid
    }, props.children));
  }
  if (props.size === 'small') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "jumbotron",
      style: {
        paddingTop: '1rem',
        paddingBottom: '1rem'
      }
    }, props.children);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "jumbotron"
  }, props.children);
}